$(function() {
  $('.sizeguide_toggler, .sizeguide_wrapper--close').click(() => {
      if ($('.sizeguide_wrapper').is(':visible')) {
        $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      } else {
        $('.sizeguide_wrapper').show();

        // On mobile, prevent body from scrolling when popup is open
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'hidden');
        }
      }
  });
  
  // Scrolling the window will close the popup
  $(window).scroll(() => {
      if ( window.innerWidth > 768 && $('.sizeguide_wrapper').is(':visible') ) {
          $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      }
  });

  // Clicks outside the wrapper will close the popup
  $(document).mouseup(e => {
      if (!$('.sizeguide_wrapper').is(e.target) && $('.sizeguide_wrapper').has(e.target).length === 0) {
          $('.sizeguide_wrapper').hide();

        // On mobile, allow body to scroll again
        if ( window.innerWidth <= 768 ) {
            $('body').css('overflow', 'auto');
        }
      }
  });
  
}); // DOM Loaded

// Raptor Tracking Integration with Shopify Theme
document.addEventListener('DOMContentLoaded', function() {
  // Check if Raptor tracking is enabled via theme settings
  if (typeof theme === 'undefined' || !theme.settings || !theme.settings.raptorBasketTrackingEnabled) {
    return; // Exit if tracking is disabled
  }
  
  // Get debug setting from theme settings
  const debugging_enabled = theme.settings.raptorDebugEnabled || false;
  
  // Helper function for conditional logging
  function log(message, ...args) {
    if (debugging_enabled) {
      console.log(message, ...args);
    }
  }
  
  // Helper function for conditional error logging
  function logError(message, ...args) {
    if (debugging_enabled) {
      console.error(message, ...args);
    }
  }
  
  // Helper function for conditional warning logging
  function logWarn(message, ...args) {
    if (debugging_enabled) {
      console.warn(message, ...args);
    }
  }
  
  log('🚀 Raptor Tracking: DOM Content Loaded - Starting initialization...');
  
  // Generate a unique client ID for tracking
  function generateClientId() {
    let clientId = localStorage.getItem('raptor_client_id');
    if (!clientId) {
      clientId = 'client_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('raptor_client_id', clientId);
      log('🆔 Raptor Tracking: Generated new client ID:', clientId);
    } else {
      log('🆔 Raptor Tracking: Using existing client ID:', clientId);
    }
    return clientId;
  }

  // Get current basket content as comma-separated string of product IDs
  function getBasketContent() {
    try {
      // Try to get cart data from the page if available
      const cartItems = document.querySelectorAll('[data-cart-item]');
      if (cartItems.length > 0) {
        const productIds = Array.from(cartItems).map(item => {
          const idElement = item.querySelector('[data-cart-item-id]');
          return idElement ? idElement.textContent.trim() : item.dataset.cartItemId || 'Unknown ID';
        });
        return productIds.join(', ');
      }
      
      // Fallback: try to get from cart.js endpoint
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.items && cart.items.length > 0) {
            return cart.items.map(item => item.id || item.variant_id).join(', ');
          }
          return '';
        })
        .catch(() => '');
    } catch (error) {
      logError('❌ Raptor Tracking: Error getting basket content:', error);
      return '';
    }
  }

  // Track add to cart events
  async function trackAddToCart(productData) {
    log('📦 Raptor Tracking: trackAddToCart called with data:', productData);
    
    if (!window.raptor) {
      logError('❌ Raptor Tracking: window.raptor is not available!');
      return;
    }
    
    if (!productData) {
      logError('❌ Raptor Tracking: No product data provided!');
      return;
    }
    
    // Get current basket content
    const basketContent = await getBasketContent();
    log('🛒 Raptor Tracking: Current basket content:', basketContent);
    
    const trackingData = {
      p1: "basket",
      p2: productData.variant_id || productData.id,
      p3: productData.title,
      p4: productData.type,
      p7: generateClientId(),
      p8: productData.vendor,
      p10: basketContent || 'Empty Basket',
      p11: Date.now().toString(),
      p12: productData.price,
      p13: productData.quantity || 1,
      p18: productData.id
    };
    
    log('📊 Raptor Tracking: Sending tracking data to Raptor:', trackingData);
    
    try {
      raptor.push("trackEvent", trackingData);
      log('✅ Raptor Tracking: Successfully sent data to Raptor');
    } catch (error) {
      logError('❌ Raptor Tracking: Error sending data to Raptor:', error);
    }
  }

  // Intercept and monitor /cart/add.js requests
  function interceptCartAddRequests() {
    log('🔍 Raptor Tracking: Setting up /cart/add.js request interception...');
    
    // Store the original fetch function
    const originalFetch = window.fetch;
    
    // Override fetch to intercept cart add requests
    window.fetch = function(...args) {
      const url = args[0];
      
      // Log ALL fetch requests for debugging
      log('🌐 Raptor Tracking: Fetch request detected:', url);
      
      // Check if this is a cart add request
      if (typeof url === 'string' && url.includes('/cart/add.js')) {
        log('🎯 Raptor Tracking: /cart/add.js request detected!');
        log('📋 Raptor Tracking: Request URL:', url);
        log('📋 Raptor Tracking: Request options:', args[1]);
        
        // Call the original fetch
        return originalFetch.apply(this, args)
          .then(response => {
            log('📦 Raptor Tracking: /cart/add.js response received');
            
            // Clone the response so we can read it
            const responseClone = response.clone();
            
            // Process the response
            responseClone.json().then(data => {
              log('📊 Raptor Tracking: Cart add response data:', data);
              
              if (data && data.id) {
                // Extract product information from the response
                const productData = {
                  id: data.id,
                  variant_id: data.variant_id || data.id,
                  title: data.product_title || data.title || 'Unknown Product',
                  type: data.product_type || 'Unknown Type',
                  vendor: data.vendor || 'Unknown Vendor',
                  price: data.price || 0,
                  quantity: data.quantity || 1
                };
                
                log('🔄 Raptor Tracking: Processed product data from response:', productData);
                trackAddToCart(productData);
              } else {
                logWarn('⚠️ Raptor Tracking: No valid product data in response');
              }
            }).catch(error => {
              logError('❌ Raptor Tracking: Error parsing response:', error);
            });
            
            // Return the original response
            return response;
          })
          .catch(error => {
            logError('❌ Raptor Tracking: Error in cart add request:', error);
            return originalFetch.apply(this, args);
          });
      }
      
      // For all other requests, use the original fetch
      return originalFetch.apply(this, args);
    };
    
    log('✅ Raptor Tracking: /cart/add.js request interception set up successfully');
  }

  // Also try to intercept XMLHttpRequest for older cart implementations
  function interceptXMLHttpRequest() {
    log('🔍 Raptor Tracking: Setting up XMLHttpRequest interception...');
    
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      log('🌐 Raptor Tracking: XMLHttpRequest open:', method, url);
      this._raptorUrl = url;
      return originalOpen.apply(this, [method, url, ...args]);
    };
    
    XMLHttpRequest.prototype.send = function(data) {
      if (this._raptorUrl && this._raptorUrl.includes('/cart/add.js')) {
        log('🎯 Raptor Tracking: XMLHttpRequest /cart/add.js detected!');
        log('📋 Raptor Tracking: Request data:', data);
        
        // Listen for response
        this.addEventListener('load', function() {
          log('📦 Raptor Tracking: XMLHttpRequest response received');
          try {
            const responseData = JSON.parse(this.responseText);
            log('📊 Raptor Tracking: XMLHttpRequest response data:', responseData);
            
            if (responseData && responseData.id) {
              const productData = {
                id: responseData.id,
                variant_id: responseData.variant_id || responseData.id,
                title: responseData.product_title || responseData.title || 'Unknown Product',
                type: responseData.product_type || 'Unknown Type',
                vendor: responseData.vendor || 'Unknown Vendor',
                price: responseData.price || 0,
                quantity: responseData.quantity || 1
              };
              
              log('🔄 Raptor Tracking: Processed product data from XMLHttpRequest:', productData);
              trackAddToCart(productData);
            }
          } catch (error) {
            logError('❌ Raptor Tracking: Error parsing XMLHttpRequest response:', error);
          }
        });
      }
      
      return originalSend.apply(this, [data]);
    };
    
    log('✅ Raptor Tracking: XMLHttpRequest interception set up successfully');
  }
  
  // Set up both interceptions
  interceptCartAddRequests();
  interceptXMLHttpRequest();
  
  // Also listen for the original custom event as backup
  document.addEventListener('ajaxProduct:added', function(event) {
    log('🎯 Raptor Tracking: ajaxProduct:added event detected (backup method)!');
    log('📋 Raptor Tracking: Event details:', event);
    
    if (event.detail && event.detail.product) {
      const product = event.detail.product;
      log('📦 Raptor Tracking: Product data from event:', product);
      
      const processedData = {
        id: product.id,
        variant_id: product.variant_id,
        title: product.product_title || product.title,
        type: product.product_type,
        vendor: product.vendor,
        price: product.price,
        quantity: 1
      };
      
      log('🔄 Raptor Tracking: Processed product data from event:', processedData);
      trackAddToCart(processedData);
    }
  });

  // Track cart updates (quantity changes, removals, etc.)
  document.addEventListener('cart:updated', function(event) {
    log('🔄 Raptor Tracking: Cart updated event detected');
    
    if (event.detail && event.detail.cart) {
      const cart = event.detail.cart;
      log('📋 Raptor Tracking: Cart update details:', cart);
      
      // Get current basket content after update
      getBasketContent().then(basketContent => {
        log('🛒 Raptor Tracking: Updated basket content:', basketContent);
        
        // Send tracking for cart update
        if (window.raptor) {
          const trackingData = {
            p1: "basket_update",
            p7: generateClientId(),
            p10: basketContent || 'Empty Basket',
            p11: Date.now().toString()
          };
          
          log('📊 Raptor Tracking: Sending cart update tracking data:', trackingData);
          
          try {
            raptor.push("trackEvent", trackingData);
            log('✅ Raptor Tracking: Successfully sent cart update data to Raptor');
          } catch (error) {
            logError('❌ Raptor Tracking: Error sending cart update data to Raptor:', error);
          }
        }
      });
    }
  });

  // Track when cart is emptied
  function trackCartEmptied() {
    if (window.raptor) {
      const trackingData = {
        p1: "basket_emptied",
        p7: generateClientId(),
        p10: '', // Empty basket
        p11: Date.now().toString()
      };
      
      log('📊 Raptor Tracking: Sending cart emptied tracking data:', trackingData);
      
      try {
        raptor.push("trackEvent", trackingData);
        log('✅ Raptor Tracking: Successfully sent cart emptied data to Raptor');
      } catch (error) {
        logError('❌ Raptor Tracking: Error sending cart emptied data to Raptor:', error);
      }
    }
  }

  // Listen for cart rebuilds to detect when cart is emptied
  document.addEventListener('cart:build', function(event) {
    log('🔨 Raptor Tracking: Cart rebuild event detected');
    
    // Check if cart is empty after rebuild
    setTimeout(() => {
      getBasketContent().then(basketContent => {
        if (!basketContent || basketContent.trim() === '') {
          log('🛒 Raptor Tracking: Cart appears to be empty after rebuild');
          trackCartEmptied();
        }
      });
    }, 100);
  });

  // Check if Raptor is available
  if (window.raptor) {
    log('✅ Raptor Tracking: Raptor library is available');
    log('🔧 Raptor Tracking: Raptor object:', window.raptor);
  } else {
    logWarn('⚠️ Raptor Tracking: Raptor library not yet loaded, waiting...');
    
    // Check again after a delay
    setTimeout(() => {
      if (window.raptor) {
        log('✅ Raptor Tracking: Raptor library now available after delay');
      } else {
        logError('❌ Raptor Tracking: Raptor library still not available after delay');
      }
    }, 2000);
  }

  // Log all available cart-related events for debugging
  log('🔍 Raptor Tracking: Available cart events to listen for:');
  log('   - ajaxProduct:added (main event we\'re listening to)');
  log('   - cart:updated (cart quantity changes)');
  log('   - cart:build (cart rebuilds)');
  
  log('🎉 Raptor Tracking: Initialization complete!');
  log('📝 Raptor Tracking: Ready to track cart additions');
});